import { Component, inject, input, ViewEncapsulation } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "src/app/material.module";
import { CaseOverviewChartComponent } from "../../charts/case-overview-chart/case-overview-chart.component";
import { CaseOverviewWidgetKpi } from "../../models/dashboard-widget-kpi.model";
import { DashboardListNavigationContext } from "../../models/dashboard-list-navigation.model";
import { DashboardNavigationService } from "../../services/dashboard-navigation.service";

@Component({
  selector: "app-dashboard-case-overview-widget",
  standalone: true,
  imports: [MaterialModule, TranslateModule, CaseOverviewChartComponent],
  templateUrl: "./case-overview-widget.component.html",
  encapsulation: ViewEncapsulation.None,
})
export class CaseOverviewWidgetComponent {
  private readonly navigationSvc = inject(DashboardNavigationService);

  readonly kpi = input.required<CaseOverviewWidgetKpi>();
  readonly listNavigation = input.required<DashboardListNavigationContext>();

  onViewCases(): void {
    this.navigationSvc.navigateToCasesList(this.listNavigation());
  }
}
